import { Injectable } from '@angular/core';
import { GLOBAL_DATA_KEY } from '@core/configs/global-data-key.config';
import { SESSION_STORAGE_KEY } from '@core/configs';
import { SessionContextService } from './session-context.service';
import { SessionStorageService } from './session-storage.service';

@Injectable({
  providedIn: 'root',
})
export class GlobalDataService {
  constructor(
    private readonly sessionStorageService: SessionStorageService,
    private readonly sessionContextService: SessionContextService
  ) {

  }
  private data: { [key in GLOBAL_DATA_KEY]?: any } = {};

  set(key: GLOBAL_DATA_KEY, value: any): void {
    this.data[key] = value;
  }

  get(key: GLOBAL_DATA_KEY): any {
    return this.data[key];
  }

  clear(): void {
    this.data = {};
  }

  setGlobalData() {
    let officeSelected = this.sessionContextService.getOfficeSelected<any>();
    let staffInfo = this.sessionContextService.getStaffInfo<any>();
    let daiInfo = this.sessionStorageService.getSessionData(SESSION_STORAGE_KEY.daiInfo);
    let corpPrefix = this.sessionContextService.getCorpPrefix();
    if (officeSelected) {
      this.set(GLOBAL_DATA_KEY.officeSelected, officeSelected);
      this.set(GLOBAL_DATA_KEY.officeCd, officeSelected.officeCd);
      this.set(GLOBAL_DATA_KEY.corpCd, officeSelected.corpCd);
      this.set(GLOBAL_DATA_KEY.corpPrefix, corpPrefix);
    }

    if (staffInfo) {
      this.set(GLOBAL_DATA_KEY.staffInfo, staffInfo);
      this.set(GLOBAL_DATA_KEY.staffCd, staffInfo.stfCd);
    }
    if (daiInfo) {
      this.set(GLOBAL_DATA_KEY.userInfo, daiInfo);
    }
  }
}
